/* JOLI POT, aperçus de pots partagés (assets/jp-pot-apercu.js) : page Idées de messages et articles.
   JPPOT.decouper(t) découpe un message en lignes, JPPOT.svg(t) dessine le pot, JPPOT.sansBarre(t) texte affiché, JPPOT.loupe(...) aperçu en grand. */
window.JPPOT = window.JPPOT || (function () {
  var POL = "'JP Sacramento', 'Brush Script MT', cursive", ctx = null, cache = {}, NS = 0;
  var HAUT = 80, BAS = 154;
  function largeur(t) {
    if (cache[t] != null) return cache[t];
    if (!ctx) { try { ctx = document.createElement('canvas').getContext('2d'); } catch (e) {} }
    var w = ctx ? (ctx.font = '700 10px ' + POL, ctx.measureText(t).width / 10) : t.length * 0.42;
    return (cache[t] = w);
  }
  function reset() { cache = {}; ctx = null; decoupes = {}; }
  function bords(y) { var dx = (y - 76) * 11 / 88; return { g: 56 + dx + 12, d: 144 - dx - 12 }; }
  function nettoyer(t) {
    return String(t || '').replace(/(?:[♡♥❣❤]|\uD83D[\uDC93-\uDC9F\uDDA4]|\uD83E[\uDD0D\uDD0E\uDDE1\uDE77\uDE75\uDE76])️?/g, '').replace(/\s+/g, ' ').trim();
  }
  function sansBarre(t) { return String(t || '').replace(/\s*\/\s*/g, ' ').replace(/\s+/g, ' ').trim(); }
  function jetons(t) {
    var m = t.split(' '), r = [];
    m.forEach(function (w) {
      if (!w) return;
      if (r.length && /^[!?:;»%…)]+$/.test(w)) r[r.length - 1] += ' ' + w;
      else r.push(w);
    });
    for (var i = r.length - 2; i >= 0; i--) if (/^[«(]$/.test(r[i])) { r[i] = r[i] + ' ' + r[i + 1]; r.splice(i + 1, 1); }
    return r;
  }
  /* Plus grande taille (18 à 7, par pas de 0,5) où chaque ligne tient dans la largeur du pot à sa hauteur ; ws : largeurs des lignes à 1px */
  function tailleW(ws) {
    var n = ws.length;
    for (var fs = 18; fs >= 7; fs -= 0.5) {
      var lh = fs * 0.98, total = n * lh + Math.max(4, fs * 0.45) + 7.2;
      if (total > BAS - HAUT) continue;
      var y = HAUT + (BAS - HAUT - total) / 2 + lh * 0.72, ok = true;
      for (var k = 0; k < n; k++) { var bd = bords(y + k * lh); if (ws[k] * fs > bd.d - bd.g) { ok = false; break; } }
      if (ok) return fs;
    }
    return 0;
  }
  function taille(lignes) { return tailleW(lignes.map(largeur)); }
  var PETITS = /^(de|du|des|à|au|aux|le|la|les|l'|un|une|et|ou|mon|ma|mes|ton|ta|tes|son|sa|ses|ce|cet|cette|pour|par|en|je|j'|tu|il|on|nous|vous|me|te|se|que|qui|plus|si|ne|pas)$/i;
  /* Une ligne plus large que 64 (largeur maximale du pot, en haut) à la taille minimale 7 ne tient jamais : la découpe aurait la taille 0 */
  var LMAX = 64 / 7;
  var decoupes = {};
  /* Découpe en 1 à 4 lignes : on essaie toutes les coupures (dans le même ordre qu'avant, même note, même départage),
     mais on écarte tout de suite une combinaison dont une ligne ne peut pas tenir (elle aurait perdu de toute façon,
     note inférieure de 100 points). Si aucune ne tient, on reprend toutes les combinaisons, comme avant. Résultat mis en cache par texte. */
  function decouper(t0) {
    var cle = String(t0 == null ? '' : t0);
    if (decoupes.hasOwnProperty(cle)) return decoupes[cle];
    return (decoupes[cle] = calculer(cle));
  }
  function calculer(t) {
    t = nettoyer(t);
    if (/\s\/\s|\s\/|\/\s/.test(t)) { var l = t.split(/\s*\/\s*/).filter(Boolean); return { lignes: l, fs: taille(l) || 7 }; }
    var mots = jetons(t), n = mots.length, best = null;
    if (!n) return { lignes: [''], fs: 12 };
    /* Pré-calculs par mot (bonus et malus de coupure) et par segment de mots (texte et largeur, calculés une seule fois) */
    var bonus = [], segT = [], segW = [];
    for (var i = 0; i < n; i++) {
      var b = 0;
      if (/[,;:.!?]$/.test(mots[i])) b = 1;
      if (PETITS.test(mots[i].replace(/[,;:.!?]+$/, ''))) b = b | 2;
      bonus.push(b); segT.push([]); segW.push([]);
    }
    function seg(a, z) { var s = segT[a][z]; if (s == null) { s = segT[a][z] = mots.slice(a, z).join(' '); segW[a][z] = largeur(s); } return s; }
    function lw(a, z) { seg(a, z); return segW[a][z]; }
    var coupes = [], elaguer = true;
    function essai(k) {
      var ws = [], p = 0, c;
      for (c = 0; c < k; c++) { ws.push(lw(p, coupes[c])); p = coupes[c]; }
      ws.push(lw(p, n));
      var fs = tailleW(ws), s = Math.min(fs, 12.5) + Math.max(0, fs - 12.5) * 0.25, nl = k + 1;
      s -= (nl - 1) * 1.2;
      if (nl === 4) s -= 2;
      if (!fs) s -= 100;
      for (c = 0; c < k; c++) { var bb = bonus[coupes[c] - 1]; if (bb & 1) s += 2.2; if (bb & 2) s -= 0.6; }
      p = 0;
      for (c = 0; c <= k; c++) { var z = c < k ? coupes[c] : n; if (seg(p, z).length <= 2) s -= 2; p = z; }
      if (nl > 1) { var dern = seg(p0(k), n); if (/^[A-ZÀ-Ý][^ ]*[!?.]?$/.test(dern) && dern.split(' ').length === 1) s += 1.2; }
      if (!best || s > best.s) best = { s: s, fs: fs, k: k, coupes: coupes.slice(0, k) };
    }
    function p0(k) { return k ? coupes[k - 1] : 0; }
    function rec(debut, reste, prof, k) {
      if (reste === 0) {
        if (elaguer && lw(p0(prof), n) > LMAX) return;
        essai(k); return;
      }
      for (var c = debut; c <= n - reste; c++) {
        if (elaguer && lw(p0(prof), c) > LMAX) continue;
        coupes[prof] = c;
        rec(c + 1, reste - 1, prof + 1, k);
      }
    }
    var kmax = Math.min(4, n);
    for (var k = 1; k <= kmax; k++) rec(1, k - 1, 0, k - 1);
    if (!best) { elaguer = false; for (k = 1; k <= kmax; k++) rec(1, k - 1, 0, k - 1); }
    var lignes = [], p = 0;
    best.coupes.concat([n]).forEach(function (c) { lignes.push(seg(p, c)); p = c; });
    return { lignes: lignes, fs: best.fs || 7 };
  }

  /* Dessin du pot : forme, bandeau terracotta, texte sur ligne courbe, petit cœur rouge */
  var COEUR_D = 'c-1.2-1.2-6-4.2-6-7.2 0-1.9 1.2-3.1 3.1-3.1 1.2 0 2.2.7 2.9 1.9.7-1.2 1.7-1.9 2.9-1.9 1.9 0 3.1 1.2 3.1 3.1 0 3-4.8 6-6 7.2z';
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function svg(t) {
    var d = decouper(t), lignes = d.lignes, fs = d.fs, lh = fs * 0.98;
    var total = lignes.length * lh + Math.max(4, fs * 0.45) + 7.2;
    var y0 = HAUT + (BAS - HAUT - total) / 2 + lh * 0.72, id = 'jppot' + (++NS);
    var s = '<svg viewBox="30 50 140 125" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><defs>';
    lignes.forEach(function (x, k) { var y = y0 + k * lh, bd = bords(y); s += '<path id="' + id + k + '" d="M' + (bd.g - 6).toFixed(1) + ' ' + y.toFixed(1) + ' Q100 ' + (y + 4).toFixed(1) + ' ' + (bd.d + 6).toFixed(1) + ' ' + y.toFixed(1) + '"/>'; });
    s += '</defs><path d="M56 76h88l-11 88H67z" fill="#fff" stroke="#e6ddd2"/><path d="M56 76h88l-1 7H57z" fill="#000" opacity=".05"/><rect x="47" y="58" width="106" height="20" rx="3" fill="#ad513f"/>';
    lignes.forEach(function (x, k) { s += '<text font-family="' + POL.replace(/'/g, '') + '" font-size="' + fs.toFixed(1) + '" font-weight="700" fill="#1d1a17" text-anchor="middle"><textPath href="#' + id + k + '" startOffset="50%">' + esc(x) + '</textPath></text>'; });
    var yb = y0 + (lignes.length - 1) * lh + fs * 0.32 + Math.max(4, fs * 0.45) + 5.15;
    s += '<path transform="translate(100 ' + yb.toFixed(1) + ') scale(.5) translate(-100 0)" d="M100 0' + COEUR_D + '" fill="#c8102e"/></svg>';
    return s;
  }

  /* Texte d'une carte à planter : plus grande taille qui tient dans la zone */
  function ajusterCarte(papier, txSel, zoneSel, plafond) {
    var W = papier.offsetWidth; if (!W) return;
    var tx = papier.querySelector(txSel), zone = papier.querySelector(zoneSel);
    if (!tx || !zone) return;
    /* 27/10/2026 : carte loin de l'écran calculée à l'approche ; rien à refaire si largeur, texte et polices n'ont pas changé */
    if (window.IntersectionObserver && !papier._jpvu) {
      var rr = papier.getBoundingClientRect();
      if (rr.top > innerHeight + 400 || rr.bottom < -400) {
        if (!papier._jpio) { papier._jpio = new IntersectionObserver(function (l) { if (!l[0].isIntersecting) return; papier._jpio.disconnect(); papier._jpvu = true; ajusterCarte(papier, txSel, zoneSel, plafond); }, { rootMargin: '400px 0px' }); papier._jpio.observe(papier); }
        return;
      }
      papier._jpvu = true;
    }
    var cle = W + '|' + tx.textContent + '|' + (document.fonts ? document.fonts.status : '');
    if (papier._jpk === cle) return;
    papier._jpk = cle;
    var h = zone.clientHeight * 0.78, lo = 6, hi = W * (plafond || 0.075), best = lo;
    for (var k = 0; k < 12; k++) { var mid = (lo + hi) / 2; tx.style.fontSize = mid + 'px'; if (tx.scrollHeight <= h && tx.scrollWidth <= zone.clientWidth) { best = mid; lo = mid; } else hi = mid; }
    tx.style.fontSize = best + 'px';
  }

  /* Loupe : bouton rond dans l'angle bas droit de la vignette, fenêtre d'aperçu en grand */
  var styleFait = false;
  function styles() {
    if (styleFait) return; styleFait = true;
    var c = document.createElement('style');
    c.textContent = [
      '.jpz-hote{position:relative}',
      '.jpz,.jpz *,.jpz-btn{box-sizing:border-box}',
      '.jpz-btn{position:absolute;z-index:2;display:grid;place-items:center;width:34px;height:34px;padding:0;margin:0;border:1px solid rgb(87 32 11 / .18);border-radius:50%;background:#fbf4ea;color:#57200b;cursor:pointer;box-shadow:0 2px 6px rgb(87 32 11 / .12);opacity:.92;transition:transform .2s ease,color .2s ease,opacity .2s ease}',
      '.jpz-btn:hover,.jpz-btn:focus-visible{color:#ad523f;opacity:1;transform:scale(1.08)}',
      '.jpz-btn:focus-visible{outline:2px solid #ad523f;outline-offset:2px}',
      '.jpz-btn svg{width:17px;height:17px}',
      '.jpz{width:min(480px,calc(100vw - 32px));max-height:calc(100dvh - 32px);margin:auto;padding:0;border:0;border-radius:16px;background:#fbf4ea;color:#2a211c;box-shadow:0 20px 60px rgb(42 33 28 / .35);overflow:auto}',
      '.jpz::backdrop{background:rgb(42 33 28 / .55)}',
      '.jpz__in{position:relative;display:grid;gap:14px;justify-items:center;padding:44px 24px 24px;text-align:center}',
      '.jpz__fermer{position:absolute;top:8px;right:8px;display:grid;place-items:center;width:38px;height:38px;padding:0;border:0;border-radius:50%;background:transparent;color:#57200b;cursor:pointer}',
      '.jpz__fermer:hover,.jpz__fermer:focus-visible{background:#ddd1c2}',
      '.jpz__fermer svg{width:18px;height:18px}',
      '.jpz__vue{width:min(420px,100%);border-radius:14px;background:linear-gradient(170deg,#f7efe5,#efe2d2);padding:14px 10px 6px}',
      '.jpz__vue svg{display:block;width:100%;height:auto;filter:drop-shadow(0 6px 10px rgb(87 32 11 / .12))}',
      '.jpz__vue--carte{background:#f3eee6;padding:18px}',
      '.jpz__txt{margin:0;font-family:var(--heading-font-family,inherit);font-size:20px;line-height:1.3;text-wrap:balance}',
      '.jpz__mention{margin:0;font-size:13px;line-height:1.5;font-style:italic;opacity:.75}',
      '.jpz__cta{display:inline-block;padding:13px 26px;border-radius:999px;background:#ad523f;color:#fff!important;font-weight:700;font-size:15px;text-decoration:none!important}',
      '.jpz__cta:hover{background:#57200b}',
      '@media (prefers-reduced-motion:reduce){.jpz-btn{transition:none}}'
    ].join('\n');
    document.head.appendChild(c);
  }
  var ICONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21M10.5 7.8v5.4M7.8 10.5h5.4"/></svg>';
  var CROIX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var dlg = null, retour = null;
  function fenetre(hote) {
    if (dlg && dlg.isConnected && dlg.parentNode === hote) return dlg;
    if (dlg && dlg.parentNode) dlg.parentNode.removeChild(dlg);
    dlg = document.createElement('dialog');
    dlg.className = 'jpz';
    dlg.setAttribute('aria-label', 'Aperçu agrandi');
    dlg.innerHTML = '<div class="jpz__in"><button type="button" class="jpz__fermer" aria-label="Fermer">' + CROIX + '</button><div class="jpz__vue"></div><p class="jpz__txt"></p><p class="jpz__mention"></p><a class="jpz__cta" href="#"></a></div>';
    dlg.querySelector('.jpz__fermer').addEventListener('click', function () { fermer(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) fermer(); });
    dlg.addEventListener('close', function () { if (retour && retour.focus) retour.focus(); });
    /* Ajoutée dans la section, pour garder les styles des cartes à planter */
    hote.appendChild(dlg);
    return dlg;
  }
  function fermer() { if (!dlg) return; if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); if (retour && retour.focus) retour.focus(); } }
  /* o : { hote (section), vue : 'pot' ou noeud à cloner, message, mention, href, cta, carte : { txt, zone } } */
  function ouvrir(o, depuis) {
    styles();
    var d = fenetre(o.hote);
    retour = depuis || null;
    var vue = d.querySelector('.jpz__vue');
    vue.className = 'jpz__vue' + (o.carte ? ' jpz__vue--carte' : '');
    vue.innerHTML = '';
    if (o.carte && o.noeud) { var cl = o.noeud.cloneNode(true); cl.style.width = '100%'; vue.appendChild(cl); }
    else vue.innerHTML = svg(o.message);
    d.querySelector('.jpz__txt').textContent = sansBarre(nettoyer(o.message));
    var m = d.querySelector('.jpz__mention'); m.textContent = o.mention || ''; m.hidden = !o.mention;
    var a = d.querySelector('.jpz__cta'); a.href = o.href || '#'; a.textContent = o.cta || ''; a.hidden = !(o.href && o.cta);
    if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
    if (o.carte && o.noeud) ajusterCarte(vue.firstChild, o.carte.txt, o.carte.zone, o.carte.plafond);
    var f = d.querySelector('.jpz__fermer'); if (f && f.focus) f.focus();
  }
  /* Pose la loupe sur une vignette. hote : élément en position relative qui contient la vignette (li) ; cadre : l'élément dont on vise l'angle bas droit */
  var poses = [];
  function placer(p) {
    var r = p.cadre.getBoundingClientRect(), h = p.hote.getBoundingClientRect();
    if (!r.width) return;
    p.btn.style.left = (r.right - h.left - 34 - 8) + 'px';
    p.btn.style.top = (r.bottom - h.top - 34 - 8) + 'px';
  }
  /* toutes les lectures puis toutes les écritures (une seule mise en page au lieu d'une par vignette) */
  function replacer() {
    var m = poses.map(function (p) { return [p, p.cadre.getBoundingClientRect(), p.hote.getBoundingClientRect()]; });
    m.forEach(function (x) { var r = x[1], h = x[2]; if (!r.width) return; x[0].btn.style.left = (r.right - h.left - 34 - 8) + 'px'; x[0].btn.style.top = (r.bottom - h.top - 34 - 8) + 'px'; });
  }
  var rafR = 0; function replacerTard() { if (!rafR) rafR = requestAnimationFrame(function () { rafR = 0; replacer(); }); }
  var ecoute = false;
  function loupe(hote, cadre, o) {
    styles();
    hote.classList.add('jpz-hote');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'jpz-btn';
    b.setAttribute('aria-label', o.label || 'Agrandir l’aperçu');
    b.innerHTML = ICONE;
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); ouvrir(o, b); });
    hote.appendChild(b);
    var p = { hote: hote, cadre: cadre, btn: b };
    /* o.differer : placement groupé par JPPOT.replacer() */
    poses.push(p); if (!o.differer) replacerTard();
    if (!ecoute) {
      ecoute = true;
      window.addEventListener('resize', replacerTard);
      if (window.ResizeObserver) { try { new ResizeObserver(replacerTard).observe(document.body); } catch (e) {} }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(replacerTard);
    }
    return b;
  }

  return { decouper: decouper, nettoyer: nettoyer, sansBarre: sansBarre, bords: bords, reset: reset, POL: POL, svg: svg, ajusterCarte: ajusterCarte, loupe: loupe, ouvrir: ouvrir, replacer: replacer };
})();